export { FeaturesInfoTable } from './component';
